import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import { Box, Tooltip } from '@mui/material'
import { FileUpload } from '@mui/icons-material'
import { actionIconStyle } from 'components/ActionUtil'

const Import = ({
    onClick = () => { },
}) => (
    <Tooltip id={'import_action_navbar'} title={i18n.importFile}>
        <Box px={2}>
            <FileUpload onClick={onClick} sx={{ ...actionIconStyle }} />
        </Box>
    </Tooltip>
)

Import.propTypes = {
    onClick: PropTypes.func,
}

export default Import